import { render, staticRenderFns } from "./companyApprove.vue?vue&type=template&id=75929d2d&scoped=true"
import script from "./companyApprove.vue?vue&type=script&lang=ts"
export * from "./companyApprove.vue?vue&type=script&lang=ts"
import style0 from "./companyApprove.vue?vue&type=style&index=0&id=75929d2d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75929d2d",
  null
  
)

export default component.exports